import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const glCodeCategoriesAdapter = getAdapter({ idFieldName: 'value' });

const glCodeCategoriesSlice = createSlice({
  name: 'glCodeCategories',
  initialState: glCodeCategoriesAdapter.getInitialState(),
  reducers: {
    setGlCodeCategories: (state, { payload: { glCodeCategories } }) => {
      glCodeCategoriesAdapter.setAll(state, glCodeCategories);
    },
  },
});

const selectors = glCodeCategoriesAdapter.getSelectors(({ glCodeCategories }) => glCodeCategories);

export const getGlCodeCategoriesIncludingDeleted = (state) => selectors.selectAll(state);

export const getGlCodeCategories = (state) => getGlCodeCategoriesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setGlCodeCategories,
} = glCodeCategoriesSlice.actions;

export default glCodeCategoriesSlice.reducer;